module.exports = __webpack_public_path__ + "09706d36ed610a24a1283122bf2b5bab.png";